// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-1 {
    display: flex;
    flex-wrap: wrap; 
    justify-content: flex-end; 
    align-items: center;
    height: 6rem;
    width: 100%;
    padding:2rem 2.5rem;
    gap: 1rem;
    background-color: #FEFCFC;
}

.header-1 .MuiFormControl-root,
.header-1 .MuiTextField-root {
    min-width: 160px;    
    background-color: #fff; 
    border-radius: 0.5rem;     
}

@media (max-width: 768px) {
    .header-1 {
        justify-content: center;
        gap: 0.5rem;
        padding: 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/New-Analytics/new-analytics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI;QACI,uBAAuB;QACvB,WAAW;QACX,aAAa;IACjB;AACJ","sourcesContent":[".header-1 {\n    display: flex;\n    flex-wrap: wrap; \n    justify-content: flex-end; \n    align-items: center;\n    height: 6rem;\n    width: 100%;\n    padding:2rem 2.5rem;\n    gap: 1rem;\n    background-color: #FEFCFC;\n}\n\n.header-1 .MuiFormControl-root,\n.header-1 .MuiTextField-root {\n    min-width: 160px;    \n    background-color: #fff; \n    border-radius: 0.5rem;     \n}\n\n@media (max-width: 768px) {\n    .header-1 {\n        justify-content: center;\n        gap: 0.5rem;\n        padding: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
